import { Component, OnInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { PricingTableSubTypes } from '../pricing-table.component';
import { environment } from '../../../../../environments/environment';
import { CheckoutService } from '../../../../services/checkout/checkout.service';
import { isPlatformBrowser } from '@angular/common';
import { ProductType } from 'src/app/interfaces/user';

export interface PricingInfoLine {
  readonly priceAmount: string;
  readonly priceDescription: string;
}

@Component({
  selector: 'app-price-card',
  templateUrl: './price-card.component.html',
  styleUrls: ['./price-card.component.scss'],
})
export class PriceCardComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() disabledBuyNow: boolean;
  @Input() viewOnly: boolean;
  @Input() highlighted: boolean;
  @Input() showBestSeller: boolean = true;

  @Input() planId: string;
  @Input() monthlyPlanId: string;

  @Input() yearlyPrice: string;
  @Input() monthlyPrice: string;
  @Input() oneOffPrice: string;
  @Input() priceNote: string;

  @Input() description: string;
  @Input() descriptionList: string[];
  @Input() planTitle: string;
  @Input() planShortSubtitle: string;
  @Input() planLongSubtitle: string;
  @Input() hidePlusFromSubtitle: boolean;
  @Input() features: string[];
  @Input() imageUri: string;

  @Input() buttonLabel: string;
  @Input() showButton: boolean = true;
  @Input() hidePrices: boolean;
  @Input() showShortDescription: boolean;
  @Input() showInfoLine: boolean;
  @Input() showFeatures: boolean;
  @Input() hasBuyNow: boolean;
  @Input() showPeachBanner: boolean;

  @Input() pricingInfoLines: PricingInfoLine[];

  @Input() warning: string;

  @Input() hideIcon: boolean;

  @Input() 
  public doesTheUserHaveOnlyCats: boolean;

  @Input() userCurrentProductType: number;

  @Output() onSelect: EventEmitter<string> = new EventEmitter();
  @Output() onNavigateToProductPage: EventEmitter<string> = new EventEmitter();

  public alternativePlanOptionsAvailable: boolean = false;
  public useMonthlyPlan: boolean = false;
  public priceTextsVisible: boolean = true;
  public isBrowser: boolean;

  constructor(
    private checkoutService: CheckoutService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  select(): void {
    if (this.useMonthlyPlan) {
      this.onSelect.emit(this.monthlyPlanId);
    } else {
      this.onSelect.emit(this.planId);
    }
  }

  navigateToProductPage(): void {
    this.onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIBASEPLUS);
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
    this.alternativePlanOptionsAvailable = !!this.monthlyPrice && !!this.yearlyPrice;

    if (this.isBrowser) {
      const currentUrl = window.location.search;
      const params = new URLSearchParams(currentUrl);
      const learnValue = params.get('learn');
      if (learnValue !== null && learnValue.toLowerCase() === 'true') {
        this.priceTextsVisible = false;
      }
    }
  }

  public buyIdentialertSubs() {
    const selectedPlans = 
    this.planId === environment.stripePlans.identiAlertFind
      ? this.doesTheUserHaveOnlyCats
        ? [environment.stripePlans.identiAlertFindCat]
        : [this.planId, environment.stripePlans.pitPatGpsTracker]
      : [this.planId];

    const isUpgrade = this.userCurrentProductType === ProductType.Basic;
    
    this.checkoutService
    .checkout(
      selectedPlans,
      { isUpgrade }
    ).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {}
    );
  }
}
